import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tbId = 0,
    search = '',
    filters = [],
    sorts = [],
    offset = 0,
    count = 1000,
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(`${URLS.das.utableData.getList}/${tbId}`, {
        search,
        filters,
        sorts,
        offset,
        count,
    }, options);
    if (error) return { error, status };
    return content || {};
};
